/* ON LOCK — Custom cart drawer logic. D7-26 only. Padlock unlock system. */
(function(){
  var drawer=document.getElementById('olDrawer');
  if(!drawer) return;
  var overlay=document.getElementById('olDrawerOverlay');
  var itemsEl=document.getElementById('olDrawerItems');
  var BIN='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2m2 0v12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7M10 11v6M14 11v6"/></svg>';

  /* Tiers are backed by REAL mechanisms post-cutover:
       $180 -> native automatic 10% (order class)
       $200 -> existing AU free-shipping RATE
       $260 -> BXGY zeroes the gift beanie; the drawer (below) is what ADDS it.
     ⚠️ All tier maths runs on the PRE-DISCOUNT subtotal excluding the gift line
     (eligibleCents). Post-discount would be self-defeating: a $185 cart minus 10%
     is $166.50, which would un-qualify the very discount that was just granted. */
  /* 🚨 TWO NUMBERS PER TIER, AND THEY ARE NOT INTERCHANGEABLE.
       `cents` = the GATE, in pre-discount product. Internal. Never printed.
       `show`  = the MONEY THE CUSTOMER PAYS. This is the only one allowed on screen.
     Joel 21 Sep 2026, reading his own cart: "It shouldn't say 225 free shipping, because free
     shipping is at 200, you fucking banana. And free gift is at 260." He is right and he had
     already said it on 4 Sep — the banners were fixed that day, the LADDER LABELS were not,
     because they render straight out of `cents`. $225 and $289 are our mechanics; $200 and
     $260 are what lands on his bank statement and what the customer can verify on a receipt.
     → memory/customer_facing_thresholds_are_what_they_pay.md */
  var TIERS=[
    {label:'10% OFF',cents:18000, show:18000, short:'10% Off'},
    /* 22500, not 20000. The delivery profile gives free shipping at $200 measured AFTER
     discounts (Joel: "$200 coming to me"), but tier maths here runs PRE-discount. At $200
     pre-discount the drawer said UNLOCKED while Shopify saw $180 and charged freight — the
     drawer was promising something checkout would not honour. Above $180 the 10% always
     applies, so $200 received needs $222.23 of product. 22500 is that, rounded up.
     If the 10% rate or the shipping threshold changes, RECOMPUTE THIS. 30 Aug 2026. */
  {label:'FREE SHIPPING',cents:22500, show:20000, short:'Free Ship'},
    {label:'FREE GIFT',cents:28900, show:26000, short:'Free Gift'}
  ];
  /* What we are allowed to print for a tier. Falls back to the gate only if a new tier is ever
     added without a `show` — which would be a bug, so it is better to see the wrong number
     than to see nothing and not notice. */
  function tierShow(t){ return t.show!=null ? t.show : t.cents; }
  /* THE GIFT — Initial Beanie Black (78u at build time).
     BXGY zeroes any beanie line when non-beanie spend >= $260; this drawer is the only
     thing that puts one in the cart. Matching is by VARIANT ID, not line property, so a
     manually-added beanie counts as "gift present" and we never end up with two. */
  /* The gift is a $0 PRODUCT, not a discounted one — changed 3 Aug 2026, and the reason
     matters. It used to be the $48 sale beanie zeroed by the FREE BEANIE OVER $260
     automatic discount. Shopify allows exactly ONE product discount per order, so that
     discount silently killed the pre-purchase upsell's discount on every cart over $260 —
     proven live: the upsell code flipped to applicable:false the moment the beanie landed.
     Giving the beanie away at $0 uses no discount at all, so both rewards now coexist.
     LEGACY_GIFT_VARIANT is the old $48 one. Carts built before this deploy still hold that
     line, and with the old discount switched off it would bill them $48 for their free
     gift. It is recognised as a gift line so giftSync strips it and re-adds the $0 one. */
  /* GIFTS is a LADDER now, lowest threshold first. Both entries are $0 products, so a cart
     over $260 legitimately carries BOTH — no discount is involved in either, which is the
     whole reason they can coexist (see the note above).
     KEYCHAIN, added 3 Aug 2026: free on any order over $50, 80 units only. It stops on its
     own when stock runs out — a failed add flips giftOOS for the session and the tier simply
     stops firing, so there is no date to remember and nothing to switch off. */
  /* Gift RRPs are counted into "You save" because a $0 line contributes nothing to Shopify's
     total_discount — a cart carrying both gifts was under-selling itself by ~$96.
     Joel 5 Aug: "there's nothing that says the beanie's worth $48". The values are NOT here:
     they come live from the sale products via window.OL_GIFT_WORTH (see the Liquid snippet),
     so swapping a gift or repricing it updates the savings on its own. */
  /* ROSE window, AWST Thu 15 Oct 2026: ADD 2:00pm (Joel 12 Oct: was 4:00pm) to 6:00pm (public open), and a
     cart that already HAS the gift keeps it until 6:15pm (Joel: 15-min grace), then it is stripped.
     Clock = Shopify's server time from /cart.js (Date header), never the phone's clock.
     KILL SWITCH: shop metafield onlock.rose_gift_off = true -> window.OL_ROSE_GIFT_OFF (drawer liquid).
     TEST HOOK: window.OL_ROSE_TEST {now, shorts:[ids], cap, socks} is IGNORED on the live (main)
     theme, so nobody can fake the clock from a console on the real store. */
  var ROSE_TEST=(window.Shopify && window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role!=='main' && window.OL_ROSE_TEST) || null;
  var ROSE_SHORTS=(ROSE_TEST && ROSE_TEST.shorts) || [43650002714737,43650002747505,43650002780273,43650002813041,43650002845809,43650002878577];
  var ROSE_CAP=(ROSE_TEST && ROSE_TEST.cap) || 67631260172401, ROSE_SOCKS=(ROSE_TEST && ROSE_TEST.socks) || 67631260270705;
  var ROSE_ON=Date.UTC(2026,9,15,5,0), /* opened 1PM, Joel 15 Oct: 'set the shorts thing to work now, I want to test it' */ ROSE_ADD_UNTIL=Date.UTC(2026,9,15,10,0), ROSE_KEEP_UNTIL=Date.UTC(2026,9,15,10,15);
  var SERVER_SKEW=0;
  function nowMs(){ return (ROSE_TEST && ROSE_TEST.now) ? +ROSE_TEST.now : Date.now()+SERVER_SKEW; }
  var GIFTS=[
    {variant:44026194067569, tier: 28900, paid: 26000, label:'FREE GIFT'},  /* INITIAL STRAP BACK BLACK = live gift from 2 Nov 2026 (Joel: "switch it to the initial white or initial black, whichever has the most stock" - black 41 vs white 13). 31 moved to the gift SKU, 10 left for sale. Baby Blue retired at 11 left. */
    /* D10 ROSE SHORTS GIFT (Joel 8 Oct 2026). Buy LIL LOCK SHORTS - BLACK ft. ROSE in the drop-night
       password window and the cap + a pair of White socks go in free. Not a spend tier: earned by the
       SHORTS being in the cart, inside the window. Cap first; the socks only ever ride WITH the cap
       (needs), so when the caps run out both stop. Stamped _gift:'rose', NOT '1' — the upsell's
       checkout sweep (onlock-preupsell.js) strips every _gift:'1' line on a cart under $260 paid,
       which would pull these off every ~$94 shorts order. Window + kill switch: see ROSE_* below. */
    {variant:ROSE_CAP, promo:'rose', label:'FREE WITH THE ROSE SHORTS'},
    {variant:ROSE_SOCKS, promo:'rose', needs:ROSE_CAP, label:'FREE WITH THE ROSE SHORTS'}
  ];
  function roseLive(keep){
    if(window.OL_ROSE_GIFT_OFF) return false;
    var n=nowMs(); return n>=ROSE_ON && n<(keep?ROSE_KEEP_UNTIL:ROSE_ADD_UNTIL);
  }
  function cartHas(cart,ids){ return cart.items.some(function(it){ return ids.indexOf(it.variant_id)>-1 && it.quantity>0; }); }
  /* ONE question for every gift: is it earned on this cart right now? keep=true is the
     "already in the cart" test (uses the grace), keep=false the "may we add it" test. */
  function earns(g,cart,elig,paid,keep){
    if(g.promo==='rose'){
      if(!roseLive(keep) || !cartHas(cart,ROSE_SHORTS)) return false;
      return !g.needs || cartHas(cart,[g.needs]);
    }
    return elig>=g.tier && !(paid<g.paid);
  }
  /* RETIRED GIFTS — recognised so any cart still holding one gets it STRIPPED, but never
     offered again. The keychain giveaway ran out on 9 Aug (all 80 gone).
     ⚠️ DO NOT rely on Shopify to stop an exhausted gift. Verified live 9 Aug: with the
     variant at available:0, availableForSale:false and policy DENY, /cart/add.js STILL
     returned 200 and put it in the cart — because on_hand was 11 with all 11 committed to
     unfulfilled orders. Customers were getting a free gift that could not be shipped.
     A gift must be retired HERE when its stock is gone, not left to the platform. */
  /* 43857620107377 = the free BEANIE, retired 13 Aug 2026 when the gift became the strap
     back (Joel). 11 were left; the 6 already committed to unfulfilled orders still ship. */
  /* 44318532862065 = the free WHITE strapback, retired 17 Sep 2026. It hit 0 on Mon 14 Sep with only
     5 white strapbacks left in the whole building, and 9 customers who cleared the $260 promise got
     nothing (it cannot add at 0 with DENY). Joel 17 Sep: "just change it to the black one". The gift
     is BLACK again (44026194067569, 83 in the gift SKU + 9 on sale = 92 physical). Retired here so any
     cart still holding a white gift line gets it stripped. */
  /* 44026194067569 = the free BLACK strapback, retired 4 Oct 2026 — available hit 0 (Joel: "swap it to the white right now"). */
  /* 44318532862065 = the free WHITE strapback, retired 15 Oct 2026 (D10): gift became Lil Lock Black ft Baby Blue (Joel). */
  /* 67684284432497 = the free LIL LOCK BLACK ft. BABY BLUE, retired 18 Oct 2026: gift became Black ft. Pink (Joel). */
  /* 67631260172401 = the free LIL LOCK BLACK ft. PINK, retired 23 Oct 2026: gift became Soft White ft. Blood Red (Joel). ROSE_CAP still names it, but the Rose window closed 15 Oct. */
  /* 67802058621041 = the free LIL LOCK SOFT WHITE ft. BLOOD RED, retired 28 Oct 2026 at 15 left: gift back to Black ft. Baby Blue (Joel). */
  var RETIRED_GIFT_VARIANTS=[43860299186289,43857620107377,44318532862065,67631260172401,67802058621041,67684284432497];
  /* RRP comes from the LIVE sale product, injected by the Liquid snippet — never hardcoded.
     Swap the gift or reprice it and "You save" follows on its own. */
  var GIFT_WORTH=window.OL_GIFT_WORTH||{};
  function worthOf(variantId){ return parseInt(GIFT_WORTH[String(variantId)],10)||0; }
  var LEGACY_GIFT_VARIANT=43114752573553;
  function isRetiredGift(id){ return RETIRED_GIFT_VARIANTS.indexOf(id)>-1; }
  var GIFT_TIER=28900;   /* kept: the reward BAR still tops out at the beanie tier */
  var giftBusy=false, giftOOS={}, lastCart=null;

  function giftFor(id){ for(var i=0;i<GIFTS.length;i++){ if(GIFTS[i].variant===id) return GIFTS[i]; } return null; }
  function isGiftLine(it){ return !!giftFor(it.variant_id) || it.variant_id===LEGACY_GIFT_VARIANT || isRetiredGift(it.variant_id); }
  /* legacy = the old $48 beanie; retired = a giveaway that has run out. Both get stripped. */
  function isLegacyGift(it){ return it.variant_id===LEGACY_GIFT_VARIANT || isRetiredGift(it.variant_id); }

  /* ── MULTI-CURRENCY (7 Sep 2026) ─────────────────────────────────────────
     Shopify Markets serves /cart.js in the LOCAL presentment currency. Every tier
     here is denominated in the SHOP currency (AUD). Without this, an NZ cart of
     NZ$289 would clear the A$289 gift tier and every reward — free hat included —
     would unlock for roughly 8-9% less real money.
     Shopify.currency.rate is "1.0" on the AU storefront, so FX === 1 and this is a
     mathematical NO-OP today. It only starts acting when a local currency is on.
     RULE: eligibleCents() returns SHOP-currency cents, so every tier comparison
     below keeps working untouched. To DISPLAY a shop-currency amount use moneyAud();
     money() is for values that already came out of the cart in local currency. */
  var FX = (function(){
    try { var r = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
          return (isFinite(r) && r > 0) ? r : 1; } catch(e){ return 1; }
  })();
  function toLocal(auCents){ return Math.round(auCents * FX); }
  function toShop(localCents){ return Math.round(localCents / FX); }
  /* NZ FREE SHIPPING AT NZ$200 (Joel 26 Sep 2026: "whatever converts to 200 AUD, 200 NZ").
     The NZ delivery zone's free rate is TOTAL_PRICE >= A$157 (NZ prices round UP ~2-3% over
     the FX rate, so A$157 is what a NZ$200 cart is worth either way). Below A$180 there is no
     10% so the goods gate is the rate gate. If either number moves, move BOTH. */
  if (window.Shopify && window.Shopify.country === 'NZ') {
    TIERS.forEach(function(t){ if (t.label === 'FREE SHIPPING') { t.cents = 15700; t.showLocal = 20000; } });
    TIERS.sort(function(a,b){ return a.cents - b.cents; });
  }
  function eligibleCents(cart){
    /* pre-discount, gift excluded — the customer-facing "spend" number.
       Normalised to SHOP currency so the TIERS comparisons stay valid. */
    var t=0;
    cart.items.forEach(function(it){ if(!isGiftLine(it)) t+=it.original_line_price; });
    return toShop(t);
  }
  /* WHAT THE CUSTOMER ACTUALLY PAYS for goods — after every discount the cart knows about
     (the automatic 10%, and any code a link has applied to the cart), before shipping.
     The gift is $0 so it adds nothing. SHOP currency, same as eligibleCents().
     Joel 11 Sep 2026, on #8627 — three tees = $300 of goods, took the upsell, PAID $238.50,
     got the hat: "an order that has spent $238... they've got the free strap back... not
     acceptable." The site promises the gift at "$260+ SPEND", so spend is what gates it.
     18 of 70 gift orders 1-10 Sep paid under $260 and got it anyway; 11 via the upsell.
     eligibleCents() is still the goods number the reward BAR is drawn from. */
  function paidCents(cart){ return toShop(cart.total_price); }
  /* Removing a gift is respected for the session — per gift since 8 Oct, so binning the Rose cap
     doesn't also cancel the $260 hat. The old all-gifts key is still honoured for the hat. */
  function giftDismissed(v){ try{ return (!giftFor(v)||!giftFor(v).promo) && sessionStorage.getItem('ol_gift_dismissed')==='1' || sessionStorage.getItem('ol_gift_dismissed_'+v)==='1'; }catch(e){ return false; } }

  /* ONE action per pass, then return. giftSync re-runs on every cart change, so doing a
     single add/remove and letting the next pass handle the rest keeps two gifts from racing
     each other into a double-add. */
  /* WHY A GIFT DID OR DIDN'T LAND — written to a cart attribute so it rides onto the ORDER.
     Order #7807 lost both gifts on a $270 cart and left no trace: three theories, all
     unprovable after the fact, because nothing recorded what giftSync actually did. This is
     the same trick the upsell already uses (_upsell_why) and it needs no new infrastructure —
     next time one goes missing the order itself says whether it was added, failed, out of
     stock, dismissed, or never attempted. Fire-and-forget: a logging failure must never
     affect the cart. */
  var giftLogged='';
  function giftLog(state){
    if(state===giftLogged) return;          /* don't spam /cart/update.js on every repaint */
    giftLogged=state;
    fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({attributes:{'_gift_why':state}})}).catch(function(){});
  }

  function giftSync(cart){
    if(giftBusy) return;
    var elig=eligibleCents(cart), paid=paidCents(cart);
    var present={};
    var legacy=null, dupe=null, unearned=null;
    cart.items.forEach(function(it){
      /* legacy OR retired -> flag for removal. Must use isLegacyGift, not a bare id check:
         a retired gift is no longer in GIFTS, so giftFor() returns null and the line would
         otherwise fall straight through and stay in the cart forever. */
      if(isLegacyGift(it)){ legacy=it; return; }
      var g=giftFor(it.variant_id);
      if(!g) return;
      present[g.variant]=true;
      if(it.quantity>1) dupe=it;
      if(!earns(g,cart,elig,paid,true)) unearned=it;   /* below its tier / shorts gone / window closed */
    });

    /* Old $48 beanie from a pre-cutover cart. The discount that made it free is gone, so
       leaving it would bill them for a gift. Drop it; the next pass re-adds the $0 one. */
    /* After each single action, run again IF the cart actually changed. change() repaints while
       giftBusy is still true, so that repaint's giftSync is skipped — with one gift nobody noticed,
       with the Rose cap + socks the socks stayed behind when the shorts came out (caught in the
       8 Oct phone test). Re-running only on a real change means a failing request can't loop. */
    var before=cart.item_count+':'+cart.items.length;
    function again(){ giftBusy=false; if(lastCart && (lastCart.item_count+':'+lastCart.items.length)!==before) giftSync(lastCart); }
    if(legacy){ giftBusy=true; change(legacy.key,0).finally(again); return; }
    if(dupe){   giftBusy=true; change(dupe.key,1).finally(again); return; }
    if(unearned){ giftBusy=true; change(unearned.key,0).finally(again); return; }

    for(var i=0;i<GIFTS.length;i++){
      var g=GIFTS[i];
      if(present[g.variant] || giftOOS[g.variant] || !earns(g,cart,elig,paid,false)) continue;
      if(giftDismissed(g.variant)){ giftLog('dismissed:'+g.label); continue; }
      giftBusy=true;
      (function(gift){
        /* _gift only — the visible "email us to swap" property looked cheap at checkout
           (Joel, 31 Jul). The line title carries the message on its own. */
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({id:gift.variant,quantity:1,properties:{'_gift':gift.promo||'1'}})})
          .then(function(r){ if(!r.ok) throw 0; return getCart(); })
          .then(function(c){ giftLog('added:'+gift.label); paint(c); bubble(c.item_count); })
          /* Out of stock is the EXPECTED end state for the 80-unit keychain, not a fault.
             Flagging only that gift means the beanie keeps working after keychains run out.
             RETRY THE REST OF THE LADDER IMMEDIATELY. A failed add used to consume the whole
             pass: giftSync only re-runs from paint(), and a failed add never reaches paint,
             so the next gift had to wait for another cart change. Order #7807 was the cost —
             $270 cart, the keychain add failed, and because crossing $260 was the customer's
             LAST action before checkout there was no next change, so they lost the beanie too
             and paid without either gift. Re-running here gives every remaining tier its turn
             in the same pass. giftOOS makes it terminate: each pass either acts or exits. */
          .catch(function(){
            giftLog('FAILED:'+gift.label+'@'+Math.round(elig/100));
            giftOOS[gift.variant]=true;
            giftBusy=false;
            if(lastCart) giftSync(lastCart);
          })
          .finally(again);
      })(g);
      return;
    }
    /* Loop finished without acting. Either everything earned is already present, or nothing
       is earned yet — record which, so a missing gift can be told apart from an unearned one. */
    var earned=GIFTS.filter(function(g){ return earns(g,cart,elig,paid,false); });
    var missing=earned.filter(function(g){ return !present[g.variant]; });
    if(!earned.length) giftLog('none-earned@'+Math.round(elig/100));
    else if(!missing.length) giftLog('ok:'+earned.map(function(g){return g.label;}).join('+'));
    else giftLog('MISSING:'+missing.map(function(g){return g.label;}).join('+')+'@'+Math.round(elig/100));
  }
  var MAX=TIERS[TIERS.length-1].cents;
  /* node VISUAL positions — EVENLY spread three across the bar (Joel 29 Jul).
     Was weighted [46,70,92]; the uneven gaps read as a mistake. Fill is piecewise-mapped
     below so the gold still tracks real spend against these even positions. */
  var VIS=[33.34,66.67,100];
  /* piecewise map: cart total -> gold-fill % in the even visual coords */
  function fillPct(total){
    if(total<=0) return 0;
    if(total>=MAX) return 100;
    var pts=[[0,0]]; TIERS.forEach(function(t,i){ pts.push([t.cents,VIS[i]]); });
    for(var i=1;i<pts.length;i++){
      if(total<=pts[i][0]){ var a=pts[i-1],b=pts[i];
        return a[1]+(b[1]-a[1])*(total-a[0])/(b[0]-a[0]); }
    }
    return VIS[VIS.length-1];
  }

  function money(c){ var n=c/100; return '$'+(n%1===0? n.toFixed(0): n.toFixed(2)); }
  /* SHOP-currency amounts (tiers, offer pricing) rendered in what the shopper sees */
  /* Local currency: round UP to whole dollars (NZ$227.64 read as a mistake; rounding up never
     under-promises a tier). AU (FX 1) is untouched. */
  function moneyAud(c){ var l=toLocal(c); if(FX!==1) l=Math.ceil(l/100)*100; return money(l); }
  function img(url){ return url ? url.replace(/(\.(?:jpe?g|png|webp))(\?|$)/i,'_200x$1$2') : ''; }

  function open(){ document.body.classList.add('ol-drawer-open'); render(); }
  function close(){ document.body.classList.remove('ol-drawer-open'); }

  function getCart(){ return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){
      try{ var d=Date.parse(r.headers.get('date')); if(isFinite(d)) SERVER_SKEW=d-Date.now(); }catch(e){}
      return r.json(); }); }
  function change(key,qty){
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(function(c){ paint(c); bubble(c.item_count); return c; });
  }
  function addVariant(id,btn){
    if(btn){ btn.disabled=true; btn.classList.add('is-added'); btn.textContent='✓'; }
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({id:parseInt(id,10),quantity:1})}).then(function(r){return r.json();})
      .then(function(){ return getCart(); }).then(function(c){ paint(c); bubble(c.item_count);
        setTimeout(function(){ if(btn){ btn.disabled=false; btn.classList.remove('is-added'); btn.textContent='+'; } },1100); return c; });
  }

  function renderItems(cart){
    if(!cart.items.length){ itemsEl.innerHTML='<div class="olc-empty">Your bag is empty</div>'; return; }
    itemsEl.innerHTML=cart.items.map(function(it){
      var vt=(it.variant_title && it.variant_title!=='Default Title')? it.variant_title.replace(/\s*\/\s*/g,' &middot; ') : '';
      var v=vt?'<div class="olc-line__variant">'+vt+'</div>':'';
      var gift=isGiftLine(it);
      /* gift line: gold chip instead of a qty stepper (qty is pinned to 1 anyway),
         price shows $0 once the BXGY is active. Bin stays — removing is respected. */
      /* Chip names the gift AND the threshold that earned it. Hardcoding "FREE GIFT ·
         OVER $260" was fine with one gift; with a ladder the keychain would have claimed
         the beanie's wording. Reads off the GIFTS entry so a new tier needs no edit here. */
      var gcfg = gift ? giftFor(it.variant_id) : null;
      var glabel = gcfg
        ? (gcfg.promo ? gcfg.label : gcfg.label+' &middot; OVER '+money(gcfg.paid||gcfg.tier))  /* customer sees what they PAY ($260), never the $289 goods tier (Joel 15 Oct) */
        : 'FREE GIFT';
      var mid = gift
        ? '<div class="olc-line__gift">'+glabel+'</div>'
        : '<div class="olc-line__qty"><button data-key="'+it.key+'" data-q="'+(it.quantity-1)+'" aria-label="Decrease">&minus;</button>'
          +'<span>'+it.quantity+'</span>'
          +'<button data-key="'+it.key+'" data-q="'+(it.quantity+1)+'" aria-label="Increase">+</button></div>';
      return '<div class="olc-line" data-key="'+it.key+'">'
        +'<div class="olc-line__img"><img src="'+img(it.image)+'" alt="" loading="lazy"></div>'
        +'<div class="olc-line__info"><div class="olc-line__title">'+it.product_title+'</div>'+v+mid+'</div>'
        +'<div class="olc-line__right"><button class="olc-remove" data-key="'+it.key+'" data-q="0" aria-label="Remove">'+BIN+'</button>'
        +'<div class="olc-line__price">'+money(it.final_line_price)+'</div></div></div>';
    }).join('');
  }

  function renderReward(cart){
    /* pre-discount, gift excluded — never total_price (see TIERS note) */
    var total=eligibleCents(cart);
    var fill=document.getElementById('olRewardFill'); if(fill) fill.style.width=fillPct(total)+'%';
    var next=TIERS.filter(function(t){return total<t.cents;})[0];
    var msg=document.getElementById('olRewardMsg');
    if(msg) msg.innerHTML= next ? 'Add <b>'+moneyAud(next.cents-total)+'</b> to unlock <b>'+next.label+'</b>' : "You've unlocked <b>every reward</b>";
    /* the ladder labels carry dollar amounts and are static in the liquid — localise them */
    var SHORTLAB=['10% Off','Free Ship','Free Gift'];
    /* SHOW, never CENTS. This line printed $180 \u00b7 $225 \u00b7 $289 for three weeks. */
    TIERS.forEach(function(t,i){ var el=document.getElementById('olLab'+i); if(el) el.textContent=(t.showLocal!=null ? money(t.showLocal) : moneyAud(tierShow(t)))+' \u00b7 '+(t.short||SHORTLAB[i]); });
    /* reframe cross-sell header as the path to the next unlock (Gymshark move) */
    var xh=document.getElementById('olXsellHead');
    if(xh) xh.textContent= next ? 'Add to unlock '+next.label : 'Complete the Fit';
    TIERS.forEach(function(t,i){
      var node=document.getElementById('olNode'+i), lab=document.getElementById('olLab'+i), hit=total>=t.cents;
      if(node) node.classList.toggle('is-hit',hit);
      if(lab) lab.classList.toggle('is-hit',hit);
    });
  }

  /* Show the customer what they actually saved. Read from the cart, never computed off a
     hardcoded tier — the real total is a stack (a 12% line-level app transform PLUS the 10%
     cart-level one), so any guess we made here would be wrong. */
  /* What the free gifts are actually worth. Shopify records $0 discount on a $0 line, so
     without this the beanie and keychain are invisible in the savings number. */
  function giftWorth(cart){
    var w=0;
    cart.items.forEach(function(it){
      if(giftFor(it.variant_id)) w+=worthOf(it.variant_id)*(it.quantity||1);
    });
    return w;
  }

  function renderSavings(cart){
    var orig=cart.original_total_price, now=cart.total_price, saved=(cart.total_discount||0)+giftWorth(cart);
    var wasRow=document.getElementById('olWasRow'), savedRow=document.getElementById('olSavedRow'),
        origEl=document.getElementById('olOrigTotal'), savedVal=document.getElementById('olSavedVal'),
        savedLab=document.getElementById('olSavedLabel'), totalLab=document.getElementById('olTotalLabel');
    if(!savedRow) return;
    if(saved>0 && orig>now){
      /* Struck-through total must include the gift RRPs too, or "was $340, save $130,
         total $306" doesn't add up and the whole thing looks broken. */
      if(origEl) origEl.textContent=money(orig+giftWorth(cart));
      if(savedVal) savedVal.textContent='-'+money(saved);
      /* Dollars, not a percentage (Joel 30 Jul). "$18.60" is a thing you can feel; "20.8%"
         is arithmetic, and an odd precision like that reads like a bug. The amount is
         already shown big on the right, so the label just names it. */
      if(savedLab) savedLab.textContent='You save';
      if(totalLab) totalLab.textContent='Total';
      wasRow.hidden=false; savedRow.hidden=false;
    } else {
      wasRow.hidden=true; savedRow.hidden=true;
      if(totalLab) totalLab.textContent='Subtotal';
    }
  }

  function paint(cart){ lastCart=cart; renderItems(cart); renderReward(cart); renderSavings(cart); giftSync(cart);
    var stT=document.getElementById('olStickyTotal'); if(stT) stT.textContent=money(cart.total_price);
    /* savings in the floating bar too (Joel 31 Jul) — same live number as the main savings
       row. It REPLACES the "Total" microlabel (redundant next to a big $ figure) so the bar
       stays two lines tall. */
    var stS=document.getElementById('olStickySave');
    if(stS){
      /* Must include gift RRPs exactly like the panel above, or the floating bar contradicts
         it — Joel 5 Aug saw "$130" in the cart and "$34" on the sticky bar at the same time. */
      var saved=(cart.total_discount||0)+giftWorth(cart);
      var stLab=stS.parentElement.querySelector('span');
      if(saved>0){ stS.textContent='You save '+money(saved); stS.hidden=false; if(stLab) stLab.hidden=true; }
      else { stS.hidden=true; if(stLab) stLab.hidden=false; }
    }
    stickyEmpty = cart.item_count===0; syncSticky();
    var st=document.getElementById('olSubtotal'); if(st) st.textContent=money(cart.total_price);
    var ct=document.getElementById('olCount'); if(ct) ct.textContent=cart.item_count;
    var apAmt=document.getElementById('olApAmt'); if(apAmt) apAmt.textContent=money(Math.round(cart.total_price/4));
    var ap=document.getElementById('olcAfterpay'); if(ap) ap.style.display= cart.total_price>0 ? 'flex' : 'none';
  }
  function render(){ getCart().then(paint); }
  function bubble(n){ document.querySelectorAll('.ol-cart-count,[data-cart-count],.cart-count-bubble').forEach(function(e){ e.textContent=n; }); }

  document.addEventListener('click',function(e){
    var cartBtn=e.target.closest('.ol-cart-wrap, #cart-icon-bubble, a[href$="/cart"]');
    if(cartBtn && !cartBtn.closest('#olDrawer')){ e.preventDefault(); open(); return; }
    if(e.target===overlay || e.target.closest('#olDrawerClose')){ close(); return; }
    var q=e.target.closest('#olDrawerItems button[data-q]');
    if(q){
      var key=q.getAttribute('data-key'), qty=parseInt(q.getAttribute('data-q'),10);
      /* customer deliberately removing the gift: respect it for the session, don't nag */
      if(qty===0 && lastCart){
        lastCart.items.forEach(function(it){
          if(it.key===key && isGiftLine(it)){ try{ var gc=giftFor(it.variant_id); sessionStorage.setItem(gc&&gc.promo ? 'ol_gift_dismissed_'+it.variant_id : 'ol_gift_dismissed','1'); }catch(e){} }
        });
      }
      /* OPTIMISTIC UPDATE — paint the new number BEFORE the round trip.
         Measured 4 Aug: tapping + left the qty showing the OLD value for ~2.5s while
         /cart/change.js and then giftSync's own add/repaint completed. Joel pressed it and
         "it's doing nothing". A stepper that lags that long reads as broken and gets
         double-tapped. The server response repaints over this a moment later, so a failed
         request self-corrects; the number is only ever optimistic for that instant. */
      var row=q.closest('.olc-line');
      var span=row && row.querySelector('.olc-line__qty span');
      if(span && qty>0){
        span.textContent=qty;
        var minus=row.querySelector('.olc-line__qty button[aria-label="Decrease"]');
        var plus =row.querySelector('.olc-line__qty button[aria-label="Increase"]');
        if(minus) minus.setAttribute('data-q', qty-1);
        if(plus)  plus.setAttribute('data-q', qty+1);
      }
      change(key, qty); return;
    }
    var x=e.target.closest('.olc-xadd[data-vid]');
    if(x){ addVariant(x.getAttribute('data-vid'), x); return; }
  });
  document.addEventListener('keyup',function(e){ if(e.key==='Escape') close(); });

  /* Floating mini-checkout: visible while the REAL footer checkout button is below the fold,
     hidden once you scroll down to it (and always hidden on an empty cart). The mini button
     shares .olc-checkout so the upsell intercept covers it too.
     Plain scroll GEOMETRY, not IntersectionObserver — IO's initial callback fires before the
     items render (button momentarily in view on an empty drawer) and caches a stale state,
     and IO delivery pauses entirely in background tabs, which made it untestable. Rects are
     synchronous and honest. */
  var stickyEmpty=true;
  function syncSticky(){
    var el=document.getElementById('olSticky'); if(!el) return;
    var real=document.querySelector('.olc-foot .olc-checkout'), s=document.querySelector('.olc-scroll');
    var covered=false;
    if(real && s){
      var b=real.getBoundingClientRect(), sr=s.getBoundingClientRect();
      covered = b.top < sr.bottom - b.height*0.4;   /* real button (mostly) scrolled into view */
    }
    el.hidden = stickyEmpty || covered;
  }
  (function wireSticky(){
    var s=document.querySelector('.olc-scroll');
    if(s) s.addEventListener('scroll',syncSticky,{passive:true});
    window.addEventListener('resize',syncSticky);
  })();

  /* position reward nodes + labels at even visual points once */
  (function positionNodes(){
    TIERS.forEach(function(t,i){
      var pct=VIS[i]+'%';
      var node=document.getElementById('olNode'+i); if(node) node.style.left=pct;
      var lab=document.getElementById('olLab'+i); if(lab) lab.style.left=pct;
    });
  })();

  /* ── UNEARNED-GIFT SWEEP ON EVERY PAGE VIEW (added 2026-09-09) ────────────────
     THE NET UNDER EVERY OTHER SWEEP. Read this before removing it.

     giftSync() only runs from paint(), and paint() only runs when the drawer is
     opened or a line inside it changes. onlock-preupsell.js already sweeps on both
     of its checkout exits — proceed() on 3 Sep, go() on 6 Sep, after #8459.

     Order #8570 still shipped a strapback on $210 of goods on 8 Sep, two days AFTER
     that fix, and #8459 came out the same way. Neither is a hole in those sweeps.
     Both carts were ABOVE the tier at the moment the sweep ran. The customer reached
     checkout, pressed BACK, cut the basket down, and checked out again — and a
     back-navigation from checkout is restored from bfcache, which fires no
     DOMContentLoaded and no script re-entry at all. Every existing guard runs on an
     ACTION. Nothing ran on a RETURN.

     So: re-check on every page view, including a bfcache restore.

     ⚠️ STRIP ONLY. It never adds. Adding stays exactly where it was (drawer open,
     cart change) so the reward experience is untouched and the worst this can ever
     do is remove something that was not paid for. A bug here cannot cost a sale.
     ⚠️ Fire-and-forget throughout. Any failure leaves the cart exactly as it was. */
  function sweepUnearnedGift(){
    if(giftBusy) return;
    getCart().then(function(cart){
      if(!cart || !cart.items || !cart.items.length) return;
      var elig=eligibleCents(cart), paid=paidCents(cart);
      var doomed=[];
      cart.items.forEach(function(it){
        /* same two-step identification giftSync uses: retired gifts first (giftFor
           returns null for those, so a bare tier check would leave them forever) */
        if(isLegacyGift(it)){ doomed.push(it.key); return; }
        var g=giftFor(it.variant_id);
        if(g && !earns(g,cart,elig,paid,true)) doomed.push(it.key);
      });
      if(!doomed.length) return;
      giftBusy=true;
      giftLog('stripped-onview@paid'+Math.round(paid/100));
      var chain=Promise.resolve();
      doomed.forEach(function(k){
        chain=chain.then(function(){
          return fetch('/cart/change.js',{method:'POST',
            headers:{'Content-Type':'application/json',Accept:'application/json'},
            body:JSON.stringify({id:k,quantity:0})}).catch(function(){});
        });
      });
      chain.then(function(){ return getCart(); })
        .then(function(c){
          bubble(c.item_count);
          /* only repaint if the drawer is actually on screen — this runs on every
             page, and paint() on a closed drawer would be work for nothing */
          if(document.body.classList.contains('ol-drawer-open')) paint(c); else lastCart=c;
        })
        .catch(function(){})
        .then(function(){ giftBusy=false; }, function(){ giftBusy=false; });
    }).catch(function(){});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',sweepUnearnedGift);
  else sweepUnearnedGift();
  /* bfcache restore — a BACK from checkout fires ONLY this. It is the exact door
     #8570 and #8459 came down, and the reason the 3 and 6 Sep sweeps missed them. */
  window.addEventListener('pageshow',function(e){ if(e.persisted) sweepUnearnedGift(); });

  /* ── ORPHANED UPSELL CODE SWEEP (added 3 Oct 2026) ─────────────────────────────
     #9262 (Ty Gosling, 2 Oct): tapped the Tiffany upsell tile, the upsell tee left the cart, and the
     OLUP-… code stayed bound to the CART. It landed on his normal-priced Tiffany: $100 tee, paid $75.
     The worker binds the code to PRODUCTS, not to the upsell LINE, so any entitled tee the customer
     already had (or re-adds from the PDP) picks it up. A Shopify minimum can't fix it (it only sees
     entitled items — the 30 Aug floor disaster, memory/shopify_discount_minimum_sees_entitled_items_only.md).
     RULE: an OLUP code may only sit on a cart that still holds a line added BY the upsell
     (properties._via === 'upsell'). No such line → the OLUP code comes off. Every other code stays.
     Same shape as the gift sweep: runs on page view, bfcache restore and after any cart change.
     ⚠️ STRIP ONLY, fire-and-forget. Worst case it removes a discount that wasn't earned. */
  var upsellSweepBusy=false;
  function sweepOrphanUpsellCode(){
    if(upsellSweepBusy) return Promise.resolve(false);
    return getCart().then(function(cart){
      if(!cart) return false;
      var codes=(cart.discount_codes||[]).map(function(d){ return d.code; }).filter(Boolean);
      var olup=codes.filter(function(c){ return /^OLUP-/i.test(c); });
      if(!olup.length) return false;
      var hasUpsellLine=(cart.items||[]).some(function(it){ return it.properties && it.properties._via==='upsell'; });
      /* 6 Oct 2026, #9347: she added the upsell tee, then REMOVED the item she was upselling from, and checked out
         one Monolith at $75 + ONLOCK15 = $60. An upsell price only exists ON TOP of a real purchase, so the code also
         goes when no regular PAID line is left (gift lines are $0; the Redo "free returns" line doesn't count). Joel: "Go". */
      var hasRegularLine=(cart.items||[]).some(function(it){
        return !(it.properties && it.properties._via==='upsell') && it.final_line_price>0 && !/free return/i.test(it.product_title||it.title||'') && it.sku!=='x-redo';
      });
      if(hasUpsellLine && hasRegularLine) return false;
      upsellSweepBusy=true;
      var keep=codes.filter(function(c){ return !/^OLUP-/i.test(c); });
      return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({discount:keep.join(',')})})
        .then(function(r){ return r.json(); })
        .then(function(c){ try{ giftLog('olup-orphan-stripped'); }catch(e){}
          if(document.body.classList.contains('ol-drawer-open')) paint(c); else lastCart=c; return true; })
        .catch(function(){ return false; })
        .then(function(x){ upsellSweepBusy=false; return x; }, function(){ upsellSweepBusy=false; return false; });
    }).catch(function(){ return false; });
  }
  window.olSweepOrphanUpsellCode=sweepOrphanUpsellCode;
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',sweepOrphanUpsellCode);
  else sweepOrphanUpsellCode();
  window.addEventListener('pageshow',function(e){ if(e.persisted) sweepOrphanUpsellCode(); });

  /* open after any add-to-cart */
  /* LOCAL-CURRENCY GIFT LINE (28 Sep 2026). The announcement bar and the drawer banner say "$260" in
     static liquid. An NZ shopper sees NZD prices, so "$260" read as NZ$260 while the real gate is A$260
     (~NZ$329). On a non-AUD storefront, rewrite "$260" in those two banners to the local amount.
     AU (FX 1) is untouched. Uses the same GIFT_PAID_FLOOR maths as the reward bar. */
  (function localiseGiftLine(){
    if (FX === 1) return;
    var local = moneyAud(26000);
    function fix(){
      document.querySelectorAll('.olc-ann, .ol-global-ann-msg').forEach(function(el){
        if (el.textContent.indexOf('$260') !== -1 && el.dataset.olLocal !== '1') {
          el.textContent = el.textContent.replace('$260', local);
          el.dataset.olLocal = '1';
        }
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix); else fix();
  })();

  var _f=window.fetch;
  window.fetch=function(){ var args=arguments, p=_f.apply(this,args), u=args[0]&&(''+args[0]);
    if(u && /\/cart\/add(\.js)?/.test(u)){ p.then(function(r){ if(r && r.ok) setTimeout(open,180); }); }
    /* a line removed or changed can orphan an upsell code (#9262) — re-check after it settles */
    if(u && /\/cart\/change(\.js)?/.test(u)){ p.then(function(r){ if(r && r.ok) setTimeout(sweepOrphanUpsellCode,250); }); }
    return p; };
})();


